import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postCreateUserTournament = (params) => {
    return axios.post(`${backendHost}/api/admin/tournament/create/user`, params);
};

export {
    postCreateUserTournament
}